<template>
    <div class="login-container">
        <div class="use">
            <div v-if="dialogFormVisible">
                <h4>欢迎登录</h4>
                <el-form   >
                    <el-form-item label="账号">
                        <el-input v-model="username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="password" type="password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                </el-form>
                <el-button type="primary" @click="loginFunc()" >登录</el-button>
                <el-button type="primary" @click="logonFunc()">注册</el-button>
                <span> <a  @click="getPass()">忘记密码</a></span>
                </div>
            <div v-else>
                <h4>修改密码</h4>
                <el-form :model="form">
                    <el-form-item label="账号" :label-width="formLabelWidth">
                        <el-input v-model="form.user" autocomplete="off" placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" :label-width="formLabelWidth">
                        <el-input v-model="form.phone" autocomplete="off" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" :label-width="formLabelWidth">
                        <el-input v-model="form.newPass" type="password" autocomplete="off" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = true">取 消</el-button>
                    <el-button type="primary" @click="changePass">确 定</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            username: "",
            password: "",
            dialogFormVisible:true,
            form: {
                user:'',
                phone:'',
                newPass:'',
            },
            formLabelWidth:'120px',
        };
    },
    methods: {
        //   登录
        loginFunc() {
            if(!this.username){
                this.$message.error("用户名不能为空");
                return;
            }

            if(!this.password){
                this.$message.error("密码不能为空");
                return;
            }
            if (this.username != "" && this.password != "") {
                this.$axios.post("/login", {
                    userName: this.username,
                    userPassword: this.password
                }).then(res => {

                    if (res.data.success) {
                        let resList = res.data.data;
           
                        sessionStorage.setItem("token", resList.token);
                        sessionStorage.setItem("userId", resList.user.id);
                        sessionStorage.setItem("name", resList.user.userName);
                        this.$router.push({ path: "/"});
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            }else{
                this.$message.error("请确认用户名或密码是否正确");
            }
        },
        //注册
        logonFunc(){
            this.$router.push({ path: '/logon'})
        },
        //忘记密码
        getPass(){
            this.dialogFormVisible = false;
        },
        changePass(){
            this.$axios.post("/updatePassword", {
                userName:this.form.user,
                userPhonenum:this.form.phone,
                userPassword:this.form.newPass,
            }).then(res => {

                if (res.data.success) {
                    this.$alert('修改成功,请重新登录', '提示', {
                        confirmButtonText: '确定',
                    });
                    this.dialogFormVisible = true;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        }
    },
    mounted() {
        var m = document.documentElement.clientWidth;

        if(m<1000){
            //  console.log(1)
        }
    },
};
</script>

<style scoped >
    .login-container {
        position: absolute;
        width: 100%;
        height: 100%;
        background: url("../assets/bg.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .use{
        position: absolute;
        top:30%;
        left:30%;
        width:46%;
        height:400px;
        border-radius: 10px;
        box-sizing: border-box;
        padding:60px 60px;
        text-align: center;
        background-color: #fff;
        opacity: 0.9;
    }
    .use h4{
        font-size:32px;
        margin-bottom:20px;
    }
     .use .el-input{
        width:70%;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/loginPage.vue